<script>
  const roles = [
    {
      title: 'AI Backend Developer',
      company: 'Vertica A/S',
      time: 'Apr 2024 - Present',
      highlights: [
        'Designed a multi-tenant API platform handling 30M requests per month.',
        'Cut p95 latency from 420ms to 140ms using query shaping and caching.',
        'Led incident response and reliability reviews with SLO-based alerts.'
      ],
      stack: 'Python, Postgres, MLflow, Azure Functions'
    },
    {
      title: 'Lead Programmer',
      company: 'Vertica A/S',
      time: 'Oct 2022 - Apr 2024',
      highlights: [
        'Built event-driven ingestion for 4,000+ IoT devices and sensors.',
        'Introduced CI pipelines with security scanning and automated rollbacks.',
        'Created internal SDKs that reduced integration time by 60 percent.'
      ],
      stack: '.NET, Umbraco, SQL, React'
    },
    {
      title: 'Backend Developer',
      company: 'Vertica A/S',
      time: 'Feb 2022 - Oct 2022',
      highlights: [
        'Owned billing microservices with guaranteed idempotency.',
        'Migrated core services from monolith to containerized workloads.',
        'Collaborated with product to ship data exports in two-week cycles.'
      ],
      stack: '.NET, Umbraco, SQL, React'
    },
    {
      title: 'System Architect',
      company: 'Illumi A/S',
      time: 'Oct 2019 - Feb 2022',
      highlights: [
        'Owned billing microservices with guaranteed idempotency.',
        'Migrated core services from monolith to containerized workloads.',
        'Collaborated with product to ship data exports in two-week cycles.'
      ],
      stack: '.NET, Umbraco, SQL, Angular'
    },
    {
      title: 'System Developer',
      company: 'Illumi A/S',
      time: 'Apr 2016 - Oct 2019',
      highlights: [
        'Owned billing microservices with guaranteed idempotency.',
        'Migrated core services from monolith to containerized workloads.',
        'Collaborated with product to ship data exports in two-week cycles.'
      ],
      stack: '.NET, Umbraco, SQL, AngularJS'
    }
  ];
</script>

<section class="page">
  <div class="page-header">
    <p class="eyebrow">Work Experience</p>
    <h1>Shipping resilient backend systems for real-world traffic.</h1>
    <p class="lead">
      Hands-on leadership across reliability, performance, and secure delivery.
      I focus on APIs that stay predictable under pressure and data pipelines
      that are observable end-to-end.
    </p>
  </div>

  <div class="timeline">
    {#each roles as role}
      <article class="timeline-item">
        <div class="timeline-marker" aria-hidden="true"></div>
        <div class="timeline-content">
          <header>
            <div>
              <h3>{role.title}</h3>
              <p class="muted">{role.company} · {role.time}</p>
            </div>
          </header>
          <ul>
            {#each role.highlights as highlight}
              <li>{highlight}</li>
            {/each}
          </ul>
          <div class="tag-row">       
            {#each role.stack.split(', ') as tech}
                <span class="pill">{tech}</span>
            {/each}
          </div>
        </div>
      </article>
    {/each}
  </div>
</section>
